import React, { useState, useEffect } from "react";

const LazyBackgroundImage = ({ lowSrc, highSrc, style, className }) => {
  const [bgImage, setBgImage] = useState(lowSrc);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const img = new Image();
    img.src = highSrc;
    img.onload = () => {
      setBgImage(highSrc);
      setLoaded(true);
    };
  }, [highSrc]);

  return (
    <div
      className={className}
      style={{
        ...style,
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        filter: loaded ? "blur(0px)" : "blur(10px)",
        transition: "filter 0.5s ease-out",
      }}
    />
  );
};

export default LazyBackgroundImage;
